import {Component, effect, input, signal} from '@angular/core';

@Component({
  selector: 'app-accordiion',
    imports: [
    ],
  templateUrl: './accordiion.component.html',
  styleUrl: './accordiion.component.scss'
})
export class AccordiionComponent {
    defaultOpen = input<boolean>(false)
    isOpen = signal<boolean>(this.defaultOpen());

    constructor() {
        effect(() => {
            this.isOpen.set(this.defaultOpen());
        });
    }

    toggle() {
        this.isOpen.set(!this.isOpen());
    }
}
